import { Handle, Position } from '@xyflow/react';

interface AINodeData extends Record<string, unknown> {
  label: string;
  type: 'ai';
  prompt: string;
  model?: string;
  temperature?: number;
  maxTokens?: number;
  systemPrompt?: string;
  outputVariable?: string;
}

interface AINodeProps {
  data: AINodeData;
  selected?: boolean;
}

export default function AINode({ data, selected }: AINodeProps) {
  return (
    <div
      style={{
        minWidth: '180px',
        maxWidth: '240px',
        background: 'linear-gradient(135deg, #a855f7 0%, #9333ea 100%)',
        border: selected ? '3px solid #7c3aed' : '2px solid #a855f7',
        borderRadius: '12px',
        padding: '12px 16px',
        color: 'white',
        boxShadow: selected
          ? '0 0 0 4px rgba(168, 85, 247, 0.3), 0 4px 12px rgba(0, 0, 0, 0.15)'
          : '0 4px 12px rgba(0, 0, 0, 0.15)',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
      }}
    >
      <Handle
        type="target"
        position={Position.Top}
        style={{
          width: '12px',
          height: '12px',
          background: '#a855f7',
          border: '2px solid white',
        }}
      />
      
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
        <span style={{ fontSize: '16px' }}>🤖</span>
        <span style={{ fontWeight: 'bold', fontSize: '14px' }}>{data.label}</span>
      </div>
      
      {data.prompt && (
        <div
          style={{
            fontSize: '11px',
            opacity: 0.9,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            lineHeight: '1.4',
            background: 'rgba(255,255,255,0.1)',
            padding: '6px 8px',
            borderRadius: '6px',
            marginTop: '4px',
          }}
        >
          {data.prompt}
        </div>
      )}
      
      {data.model && (
        <div
          style={{
            fontSize: '10px',
            opacity: 0.8,
            marginTop: '6px',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          }}
        >
          <span>Model:</span>
          <span style={{ fontWeight: 500 }}>{data.model}</span>
        </div>
      )}
      
      <Handle
        type="source"
        position={Position.Bottom}
        style={{
          width: '12px',
          height: '12px',
          background: '#a855f7',
          border: '2px solid white',
        }}
      />
    </div>
  );
}
